import Vue from 'vue'

// 平安银行的城市信息
const getPinganArea = (id) => {
  return new Promise((resolve, reject) => {
    Vue.prototype.sendGet({
      method: 'get',
      url: '/web/pingan-discount/area'
    }, (result) => {
      resolve(result)
    },(result) => {
      reject(result)
    })
  })
}

// 百信银行
const uploadBaixinFile = (data, callback) => {
  return new Promise((resolve, reject) => {
    Vue.prototype.sendGet({
      method: 'get',
      url: '/web/baixin-discount/upload',
      data
    }, (result) => {
      resolve(result)
    },(result) => {
      callback && callback()
      reject(result)
    })
  })
}



export {
  getPinganArea,
  uploadBaixinFile
}


// WEBPACK FOOTER //
// ./src/api/bankAgreement.js